module.exports = __webpack_public_path__ + "static/media/logo-light.b252a1c4.svg";